export const tamu_valid_email_extensions = [
    'tamu.edu',
    'email.tamu.edu',
    'exchange.tamu.edu',
    'engineering.tamu.edu',
    'library.tamu.edu',
    'cse.tamu.edu',
    'science.tamu.edu',
    'ag.tamu.edu',
    'arch.tamu.edu',
    'tamuqatar.edu.qa',
    'vetmed.tamu.edu',
    'bush.tamu.edu',
    'education.tamu.edu',
    'geos.tamu.edu',
    'tamu.edu.cn',
    'aggienetwork.com',
    'tamuc.edu',
    'tamucc.edu',
    'tamuk.edu',
    'pvamu.edu',
    'tarleton.edu',
    'westtexas.a&m.edu',
    'texarkanacollege.edu',
    'tamuct.edu',
    'tamusa.edu',
    'qatar.tamu.edu',
    'tamhsc.edu',
    'tamutech.edu',

    // Add more emails extensions here
];